export enum KycStatus {
    NotSubmitted,
    SubmissionStarted,
    Pending,
    Verified,
    VerificationFailed
}
